const { REACT_APP_BACKEND_HOST: host, REACT_APP_BACKEND_PORT: port, REACT_APP_USE_SSL } = process.env;
const protocol = REACT_APP_USE_SSL === "on" ? "https" : "http";

export const backendUrl = `${host && port ? `${protocol}://${host}:${port}` : ""}`;
